<template>
  <!-- Kontener widoku aktywnych filtrów danych pojazdu -->
  <!-- Renderowany tylko, gdy istnieje przynajmniej jeden wybrany filtr -->
  <div v-if="isChoosen()" class="filter d-flex flex-column">
    <!-- Nagłówek sekcji z tytułem i ikoną usuwania wszystkich filtrów -->
    <h5 class="margin-0">
      {{ t('vehicle-data') }}
      <!-- Ikona kosza: usuwa wszystkie filtry dla danych pojazdu -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!-- Iteracja po przefiltrowanych polach vehicleData -->
    <div
      v-for="(label, key) in filteredVehicleData"
      :key="key"
      class="d-flex info"
    >
      <!-- Jeżeli pole to filtr pojedynczy (np. rejestracja lub similarity) -->
      <span v-if="isSingle(key)">
        <single-filter-view
          :name="label"
          :field-name="key"
          :value="filtersStore.filters[key]"
        />
      </span>
      <!-- W przeciwnym wypadku używamy widoku zakresowego -->
      <span v-else>
        <range-filter-view
          :name="label"
          :type-name="key"
        />
      </span>
    </div>

  </div>
</template>

<script>
// Import store z aktualnymi filtrami (Pinia)
import { useCurrentFiltersStore } from "../../stores/currentFilters";
// Import komponentów wyświetlających wartości filtrów
import RangeFilterView from "./RangeFilterView.vue";
import SingleFilterView from "./SingleFilterView.vue";

export default {
  name: "VehicleDataFilterView",
  components: { SingleFilterView, RangeFilterView },
  
  setup() {
    // Pobranie instancji store z aktualnymi filtrami
    const filtersStore = useCurrentFiltersStore();
    return { filtersStore };
  },

  computed: {
    /**
     * Tworzy obiekt aktywnych filtrów:
     * - scala pary minX/maxX w jedną pozycję
     * - uwzględnia pojedyncze filtry
     */
    filteredVehicleData() {
      const filters = this.filtersStore.filters;
      const vehicleData = this.filtersStore.vehicleData; // Mapa {klucz: etykieta}
      const result = {};
      const handled = new Set(); // Zbiór już obsłużonych kluczy

      // Iteracja po definicjach pól vehicleData
      for (const [key, label] of Object.entries(vehicleData)) {
        if (handled.has(key)) continue; // Pomijamy przetworzone

        // Sprawdzenie prefiksów min/max w kluczu
        const match = key.match(/^(min|max)(.+)$/);
        if (match) {
          const base = match[2];
          const minKey = `min${base}`;
          const maxKey = `max${base}`;

          // Sprawdzenie, czy któraś wartość została ustawiona
          const hasMin = filters[minKey] != null && filters[minKey] !== '';
          const hasMax = filters[maxKey] != null && filters[maxKey] !== '';

          // Jeśli mamy wartość mínima lub máxima, dodajemy tylko minKey jako reprezentację zakresu
          if (hasMin || hasMax) {
            result[minKey] = label;
          }
          // Oznaczamy oba klucze jako obsłużone
          handled.add(minKey);
          handled.add(maxKey);
        } else {
          // Pojedyncze pole: dodajemy, jeśli jest ustawione
          if (filters[key] != null && filters[key] !== '') {
            result[key] = label;
          }
          handled.add(key);
        }
      }

      return result;
    },
  },

  methods: {
    /**
     * Czy istnieje jakikolwiek wybrany filtr? Wykorzystane do v-if w template
     */
    isChoosen() {
      const filters = this.filtersStore.filters;
      return Object.keys(this.filtersStore.vehicleData).some(key => filters[key] != null);
    },

    /**
     * Określa, czy dany filtr jest "single" (pojedynczy), a nie zakresowy
     */
    isSingle(name) {
      // Pojedyncze filtry: rejestracja ('plateLpr') i similarity
      return ['plateLpr', 'similarity'].includes(name);
    },

    /**
     * Usuwa wszystkie filtry związane z danymi pojazdu.
     */
    removeFilter() {
      this.filtersStore.removeItem('vehicleData');
    },
  },
};
</script>

<style scoped>
/* Kontener filtra zajmuje całą szerokość */
.filter {
  width: 100%;
}

/* Styl nagłówka z białym tłem i tłem z obrazkiem */
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Styl linii info wyświetlających wartości filtrów */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}

/* Ikona kosza do usuwania filtrów */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}

/* Klasy dla dodatkowych ikon (kategorie) można tu dodać, jeśli potrzebne */
</style>